import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { API_ENDPOINTS } from "../config/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import VehicleLink from "./VehicleLink";

const LikedPlates = () => {
  const [likedPlates, setLikedPlates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const fetchLikedPlates = async () => {
    try {
      const res = await fetch(
        `${API_ENDPOINTS.LIKED_PLATES}?page=${page}&limit=20`,
        {
          credentials: "include",
        }
      );
      if (!res.ok) throw new Error("Failed to fetch liked plates");

      const data = await res.json();
      setLikedPlates((prev) =>
        page === 1 ? data.vehicles : [...prev, ...data.vehicles]
      );
      setHasMore(data.pagination.hasMore);
      setError(null);
    } catch (err) {
      console.error("Error fetching liked plates:", err);
      setError("Failed to load liked plates");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLikedPlates();
  }, [page]);

  return (
    <div className="max-w-4xl mx-auto p-4">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Liked Plates</h1>

      {loading && page === 1 ? (
        <div className="flex justify-center items-center p-8">
          <FontAwesomeIcon
            icon={faSpinner}
            spin
            className="text-gray-400 text-2xl"
          />
        </div>
      ) : error ? (
        <div className="text-red-500 text-center p-4">{error}</div>
      ) : likedPlates.length === 0 ? (
        <div className="text-center p-8">
          <p className="text-gray-500">No liked plates yet.</p>
          <Link
            to="/explore"
            className="text-blue-500 hover:text-blue-600 mt-2 inline-block"
          >
            Explore plates
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-4">
          {likedPlates.map((vehicle) => (
            <VehicleLink key={vehicle._id} vehicle={vehicle} variant="card" />
          ))}
        </div>
      )}

      {hasMore && !loading && (
        <div className="text-center mt-8">
          <button
            onClick={() => setPage((p) => p + 1)}
            className="bg-primary-500 text-white px-6 py-2 rounded-md hover:bg-primary-600 transition-colors dark:bg-primary-600 dark:hover:bg-primary-700"
          >
            {loading ? <FontAwesomeIcon icon={faSpinner} spin /> : "Load more"}
          </button>
        </div>
      )}
    </div>
  );
};

export default LikedPlates;
